import Vue from 'vue'
import Component from 'vue-class-component'
import { Store } from 'vuex'
import RootState from '../../store/state'

@Component
export default class ContentsModal extends Vue {
  name: 'ContentsModal'
  $store: Store<RootState>

  submitEvent() {
    return this.$emit('submit')
  }

  close() {
    return this.$emit('close')
  }
}
